import { useCallback, useEffect, useState } from 'react'

import css from './sass/liveauction.module.scss'
import themeCss from '../../components/sass/theme.module.scss'
import { handleEscapeKey } from 'sites/auctions/components/utils'
import { formatMoney } from 'services/util'

export default function ItemPurchaseHistoryTable({ item, users = [] }) {

  const [showInfo, setShowInfo] = useState(false)

  const click = () => {
    let current = showInfo
    setShowInfo(!current)
  }

  const toggleModal = useCallback(() => {
      setShowInfo(false)
    }, [setShowInfo])
  
    useEffect(() => {
      const onKeyDown = (event) => handleEscapeKey(event, toggleModal)
      //add event listener for when modal is mounted
      document.addEventListener('keydown', onKeyDown)
      //clean up when modal is unmounted
      return () => document.removeEventListener('keydown', onKeyDown)
  
    }, [toggleModal])

  return (
    <div>
      <button className={css['admin-info-modal-link']} onClick={()=>click()} >{formatMoney(item.TotalItemsPurchased)}</button>
      
      {showInfo && (<>
        <div className={themeCss['modal-background']} onClick={()=>click()}> </div>
        <div className={themeCss['modal-card']}>
          <button className={`${themeCss['button']} ${themeCss['FilledBlue']} ${themeCss['centered-button']}`} onClick={()=>click()} >Close Modal</button>
          
          <h4 className={css['admin-info-modal-header']}>Purchase History for {item.Title}</h4>
          <table className={themeCss['data-table']}>
            <thead>
              <tr>
                <th>Full Name</th>
                <th>Quantity Purchased</th>
                <th>Amount Owed</th>
              </tr>
            </thead>
            <tbody>
            {users.length > 0 && users.map((user, index) => {
                return (
                  <tr key={`${user.FullName || 'buyer'}-${index}`}>
                    <td>{user.FullName}</td>
                    <td>{formatMoney(user.Quantity)}</td>
                    <td>${formatMoney(user?.AmountOwed)}</td>
                  </tr>)
              })}
            </tbody>
          </table>
        </div>
      </>)}
    </div>    
  )
}
